import React, { Component } from "react";

import { Form, Select, Textarea } from "@rocketseat/unform";

import { Row, Col, Button, Modal, notification } from "antd";

import Verde from "../Verde";
import BForm from "../Verde/BForm";
import validateVerdeData from "../Verde/Validator";

import Amarelo from "../Amarelo";
import validateAmareloData from "../Amarelo/Validator";

import Vermelho from "../Vermelho";

import api from "../../../../services/api";
import handleError from "../../../../services/apiErrorHandler";

import * as Yup from "yup";

export default class FiltroBase extends Component {
  /** Base do filtro */

  state = {
    filtro_selected: null,
    filtro_form_bottom: null,
    cor_filtro: null,
    enviando: false,
    confirm_visible: false, // Status modal de confirmação
    baixando_pasta: false
  };

  componentDidMount() {
    /** Registra o evento */
    window.addEventListener("beforeunload", this.handleReativa);
  }

  componentWillUnmount() {
    this.handleReativa();
    window.removeEventListener("beforeunload", this.handleReativa);
  }

  /**
   * Função chamada ao mudar a cor do filtro
   * @param {Object} event - Dados do evento
   */
  handleFiltroChange = event => {
    const color = event.currentTarget.value;

    if (color == 0) {
      // None
      this.setState({
        filtro_form_bottom: null,
        filtro_selected: null
      });
    }

    if (color == 1) {
      // Green
      this.setState({
        filtro_form_bottom: <BForm />,
        filtro_selected: <Verde />
      });
    }

    if (color == 2) {
      // Red
      this.setState({
        filtro_form_bottom: null,
        filtro_selected: <Vermelho />
      });
    }

    if (color == 3) {
      // Yellow
      this.setState({
        filtro_form_bottom: null,
        filtro_selected: <Amarelo />
      });
    }

    this.setState({
      cor_filtro: color
    });
  };

  /**
   * Reativa a pasta quando a página é fechada
   */
  handleReativa = async () => {
    let id = this.props.pasta.id;

    await api.put(`/pasta/${id}/`, {
      filtrando: false
    });
  };

  /**
   * Função para baixar a pasta
   */
  handlePastaBaixada = async () => {
    this.setState({
      baixando_pasta: true
    });

    /** Baixa a pasta */
    await api
      .post("/filtro/", {
        cor_filtro: "0",
        pasta: this.props.pasta.pasta
      })
      .then(response => {
        notification.success({ message: "Pasta baixada com sucesso!" });

        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch(error => {
        Modal.error({
          title: "Erro",
          content: handleError(error)
        });
      });

    this.setState({
      baixando_pasta: false
    });
  };

  /**
   * Mostra o popup de confirmação para baixar a pasta
   */
  handleConfirmModal = visible => {
    this.setState({
      confirm_visible: visible
    });
  };

  /**
   * Função ao clicar em "Enviar"
   * @param {Object} data - Dados do filtro
   */
  handleSubmit = async data => {
    /** Efetua a requisição ao back-end */
    const color = data.cor_filtro;

    console.log(data);

    if (this.state.enviando || this.state.baixando_pasta) return;

    this.setState({
      enviando: true
    });

    // Filtro verde
    if (color == "1") {
      /** Valida as informações */
      const validData = validateVerdeData(data, this.props.pasta);
      if (validData) {
        // Make request
        await api
          .post("/filtro/", {
            pasta: this.props.pasta.pasta,
            ...data
          })
          .then(response => {
            console.log(response);
            notification.success({
              message: "Filtro salvo com sucesso!"
            });

            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch(error => {
            Modal.error({
              title: "Erro",
              content: handleError(error)
            });
          });
      }
    }

    // Filtro vermelho
    if (color == "2") {
      await api
        .post("/filtro/", {
          pasta: this.props.pasta.pasta,
          ...data
        })
        .then(response => {
          notification.success({
            message: "Filtro salvo com sucesso!"
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch(error => {
          Modal.error({
            title: "Erro",
            content: handleError(error)
          });
        });
    }

    // Filtro amarelo
    if (color == "3") {
      /** Valida as informações */
      const validData = validateAmareloData(data, this.props.pasta);

      if (validData) {
        // Make request
        await api
          .post("/filtro/", {
            pasta: this.props.pasta.pasta,
            ...data
          })
          .then(response => {
            console.log(response);
            notification.success({
              message: "Filtro salvo com sucesso!"
            });

            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch(error => {
            Modal.error({
              title: "Erro",
              content: handleError(error)
            });
          });
      }
    }

    this.setState({
      enviando: false
    });
  };

  /**
   * Mostra as instruções do filtro
   */
  showInstructions = () => {
    Modal.info({
      title: "Instruções",
      width: 650,
      content: (
        <div
          style={{
            textAlign: "justify"
          }}
        >
          <p>
            <b>•</b> Quando o filtro for verde ou amarelo, sempre colocar a
            placa do 3°;
          </p>

          <p>
            <b>•</b> Se no B.O. tiver o telefone do terceiro e/ou endereço,
            colocar nos campos específicos;
          </p>

          <p>
            <b>•</b> Caso so tenha o nome do terceiro, porém completo, realizar
            pesquisa para localizar o CPF/CNPJ;
          </p>

          <p>
            <b>•</b> Sempre verificar se o B.O. é correspondente com o acidente
            em questão;
          </p>

          <p>
            <b>•</b> Quando tiver sinistro associado, verificar se o terceiro
            foi ressarcido;
          </p>

          <p>
            <b>•</b> Verificar se o condutor também é proprietário do veículo
            terceiro;
          </p>

          <p>
            <b>•</b> Quando tiver apenas o nome do proprietário, realizar
            pesquisa para localizar o CPF/CNPJ;
          </p>

          <p>
            <b>•</b> Quando o sinistro ocorreu em rodovia e o que deu causa ao
            acidente foi animal, objeto ou defeito na via, verificar se a
            rodovia é pedagiada;
          </p>

          <p>
            <b>•</b> Quando o terceiro faleceu, verificar se o condutor e o
            proprietário são os mesmos.
          </p>
        </div>
      )
    });
  };

  /**
   * Mostra um popup de erro na tela
   * @param {String} message - Mensagem de erro
   */
  handleErrorModal = message => {
    Modal.error({
      title: "Error",
      content: message
    });
  };

  initialData = {
    cor_filtro: "Selecione",
    bo_correto: "1",
    prop_is_cond: "2",
    possui_placa: "Selecione",
    tipo_devolucao: "0",
    devolucao: "0",
    devolucao_motivo: "0",
    submotivo: "0"
  };

  render() {
    let schema = null;
    let schema_obj = {
      cor_filtro: Yup.mixed().oneOf(["1", "2", "3"], "* Campo obrigatório!"),
      observacao: Yup.string()
    };

    /** Validações filtro Amarelo */
    if (this.state.cor_filtro == 3)
      schema_obj = {
        ...schema_obj,
        possui_placa: Yup.mixed().oneOf(["1", "2"], () =>
          this.handleErrorModal('* Campo "Placa do 3º" obrigatório!')
        ),
        placa: Yup.string().min(7, () =>
          this.handleErrorModal("* Placa inválida")
        ),
        bo_correto: Yup.mixed().oneOf(["1", "2"], () =>
          this.handleErrorModal('* Campo "B.O correto" obrigatório!')
        )
      };

    /** Validações filtro Verde */
    if (this.state.cor_filtro == 1)
      schema_obj = {
        ...schema_obj,
        possui_placa: Yup.mixed().oneOf(["1", "2"], () =>
          this.handleErrorModal('* Campo "Placa do 3º" obrigatório!')
        ),
        placa: Yup.string().min(7, () =>
          this.handleErrorModal("* Placa inválida")
        ),
        bo_correto: Yup.mixed().oneOf(["1", "2"], () =>
          this.handleErrorModal('* Campo "B.O correto" obrigatório!')
        ),
        prop_is_cond: Yup.mixed().oneOf(["1", "2"], () =>
          this.handleErrorModal(
            '* Campo "Proprietário é o condutor" obrigatório!'
          )
        ),
        condutor_nome: Yup.string(),
        condutor_rua: Yup.string(),
        condutor_complemento: Yup.string(),
        condutor_cidade: Yup.string(),
        condutor_cep: Yup.string(),
        condutor_cpf_cnpj: Yup.string(),
        condutor_numero: Yup.string(),
        condutor_bairro: Yup.string(),
        condutor_uf: Yup.string(),
        condutor_telefone_1: Yup.string(),
        condutor_telefone_2: Yup.string(),
        proprietario_nome: Yup.string(),
        proprietario_rua: Yup.string(),
        proprietario_complemento: Yup.string(),
        proprietario_cidade: Yup.string(),
        proprietario_cep: Yup.string(),
        proprietario_cpf_cnpj: Yup.string(),
        proprietario_numero: Yup.string(),
        proprietario_bairro: Yup.string(),
        proprietario_uf: Yup.string(),
        proprietario_telefone_1: Yup.string(),
        proprietario_telefone_2: Yup.string()
      };

    /** Validações filtro Vermelho */
    if (this.state.cor_filtro == 2) {
      schema_obj = {
        ...schema_obj,
        tipo_devolucao: Yup.string().min(2, () =>
          this.handleErrorModal("Selecione o tipo de devolução!")
        ),
        devolucao: Yup.string().min(2, () =>
          this.handleErrorModal("Selecione a devolução!")
        ),
        devolucao_motivo: Yup.string().min(2, () =>
          this.handleErrorModal("Selecione o motivo da devolução!")
        ),
        submotivo: Yup.string()
      };
    }

    schema = Yup.object().shape(schema_obj);

    return (
      <div>
        <Form
          className="filtro__form"
          schema={schema}
          onSubmit={this.handleSubmit}
          initialData={this.initialData}
        >
          <br />
          <Row gutter={8}>
            <Col span={12}>
              <div className="filtro__input_limit">
                <div className="d-flex">
                  <label>Filtro:</label>
                  <div className="filtro__input_container">
                    <Select
                      onChange={this.handleFiltroChange}
                      className="ant-input"
                      name="cor_filtro"
                      options={[
                        { id: 0, title: "Selecione" },
                        { id: 1, title: "VERDE" },
                        { id: 2, title: "VERMELHO" },
                        { id: 3, title: "AMARELO" }
                      ]}
                    />
                  </div>
                </div>
                <br />
                <div className="d-flex">
                  <label>Observação:</label>
                  <div className="filtro__input_container">
                    <Textarea name="observacao" className="ant-input" />
                  </div>
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className="filtro__input_limit">
                {this.state.filtro_selected}
              </div>
            </Col>
          </Row>
          {this.state.filtro_form_bottom}
          <div className="filtro__buttons">
            <Button type="primary" onClick={this.showInstructions}>
              Instruções
            </Button>
            <div>
              <Button
                type="danger"
                onClick={() => this.handleConfirmModal(true)}
                style={{ marginRight: "30px" }}
              >
                Pasta baixada
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                loading={this.state.enviando}
              >
                Enviar
              </Button>
            </div>
          </div>
        </Form>
        <Modal
          title="Baixar pasta"
          visible={this.state.confirm_visible}
          onOk={this.handlePastaBaixada}
          onCancel={() => this.handleConfirmModal(false)}
          okText="Confirmar"
          cancelText="Cancelar"
          confirmLoading={this.state.baixando_pasta}
        >
          <p>Deseja baixar essa pasta?</p>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Filtro/components/FiltroBase/index.js